define('views/pages/wishlist/offers/wishlist-result',['require','jquery','views/base/view','views/dialog','text!templates/pages/wishlist/offers/wishlist-result.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        View = require('views/base/view'),
        Dialog = require('views/dialog'),
        template = require('text!templates/pages/wishlist/offers/wishlist-result.ejs');

    var WishlistResultView = View.extend({
        autoRender: true,
        template: template,
        tagName: 'tr',
        listen: {
            'change model': 'render'
        },
        events: {
            'click .btn-danger': 'delete'
        },
        render: function() {
            this.destroyTooltip();
            View.prototype.render.apply(this, arguments);
            this.createToolTip();
        },

        createToolTip: function() {
            this.$('span[data-toggle=tooltip]').tooltip({ container: 'body', placement: 'bottom' });
        },

        destroyTooltip: function() {
            this.$('span[data-toggle=tooltip]').tooltip('destroy');
        },

        dispose: function() {
            if (this.disposed) { return; }

            this.destroyTooltip();

            View.prototype.dispose.apply(this, arguments);
        },

        delete: function() {
            this.model.destroy();
        }
    });

    return WishlistResultView;
});

